//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { NoGalleriesModalAction } from '../actions/noGalleriesModalActions';
import { NO_GALLERIES_MODAL_ACTIONS } from '../constants/galleriesConstants';
import { INoGalleriesModalState } from '../models/noGalleriesModalModel';

const initialState: INoGalleriesModalState = {
  isOpen: false,
};

export default function NoGalleriesModalReducer(
  state: INoGalleriesModalState = initialState,
  action: NoGalleriesModalAction,
): INoGalleriesModalState {
  switch (action.type) {
    case NO_GALLERIES_MODAL_ACTIONS.OPEN_MODAL:
      return {
        isOpen: true,
      };
    case NO_GALLERIES_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        isOpen: false,
      };
    default:
      return state;
  }
}
